import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-h6" }

import {
  PropType, ref,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalAbstract',
  props: {
  nodeName: {
    type: String as PropType<string | undefined>,
    required: false,
    default: '',
  },
  parentName: {
    type: String as PropType<string | undefined>,
    required: false,
    default: '',
  },
  additional: {
    type: String as PropType<string | undefined>,
    required: false,
    default: '',
  },
  name: {
    type: String as PropType<string | undefined>,
    required: false,
    default: '',
  },
  nodeAlias: String,
  nodeAdditional: String,
  confirm: Boolean,
  add: Boolean,
},
  emits: [
  'removeNode', 'cancel', 'createNode',
],
  setup(__props, { emit }) {

const props = __props




const confirmRemove = ref(props.confirm);
const addMode = ref(props.add);
const additionalValue = ref(props.additional);
const nameValue = ref(props.name);
const remove = (nameNode: string | undefined) => {
  emit('removeNode', nameNode);
};
const cancelAction = () => {
  emit('cancel');
};
const addNode = () => {
  const context = {};
  console.log(props, additionalValue.value, nameValue.value);
  emit('createNode', context);
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_form = _resolveComponent("q-form")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_dialog, {
      modelValue: confirmRemove.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((confirmRemove).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_actions, null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  label: "Отмена",
                  color: "primary",
                  onClick: cancelAction
                }, null, 512), [
                  [_directive_close_popup]
                ]),
                _createVNode(_component_q_btn, {
                  label: `Удалить ${props.name}`,
                  color: "negative",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (remove(props.nodeName)))
                }, null, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: addMode.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addMode).value = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"min-width":"350px"},
          class: "q-py-md"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, " Добавить " + _toDisplayString(__props.nodeAlias) + " в " + _toDisplayString(__props.parentName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_form, {
              class: "q-gutter-md full-width",
              onSubmit: _withModifiers(addNode, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_input, {
                  filled: "",
                  type: "text",
                  modelValue: nameValue.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((nameValue).value = $event)),
                  label: __props.nodeAlias
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_q_input, {
                  filled: "",
                  type: "text",
                  modelValue: additionalValue.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((additionalValue).value = $event)),
                  label: __props.nodeAdditional
                }, null, 8, ["modelValue", "label"]),
                _createElementVNode("div", null, [
                  _createVNode(_component_q_btn, {
                    size: "sm",
                    "text-color": "standard",
                    label: "Добавить",
                    type: "submit",
                    disable: !nameValue.value && !additionalValue.value
                  }, null, 8, ["disable"]),
                  _withDirectives(_createVNode(_component_q_btn, {
                    class: "q-ml-sm",
                    size: "sm",
                    "text-color": "standard",
                    label: "Отмена",
                    onClick: cancelAction
                  }, null, 512), [
                    [_directive_close_popup]
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})